





















import datepicker from './Datepicker.vue'

export default {
  name: 'Datefield'

  props: 
    id: ''
    label: ''
    value: ''
    validate:
      default: ''

  components: 
    'v-datepicker': datepicker

  mounted: () ->
    componentHandler.upgradeElements @$el

  methods: 
    onInput: (event) ->
      @$emit 'input', event
      componentHandler.upgradeElements @$el
      
  watch:
    value: (val) ->
      @$validator.validate(@label, val)
      if @errors.any()
        @$emit 'errors', @errors.all()

  computed:
    errorMsg: () ->
      @errors.all().join('<br>')
  
}




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/form/Datefield.vue